"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIErrorMessage;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _I18n = _interopRequireDefault(require("I18n"));

var _H = _interopRequireDefault(require("../elements/headings/H4"));

var _UIResultsMessage = _interopRequireDefault(require("../results/UIResultsMessage"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _illustrationName = require("../utils/propTypes/illustrationName");

var errorTypes = {
  badRequest: {
    image: 'errors/general',
    title: function title() {
      return _I18n.default.text('ui.UIErrorMessage.badRequest.title');
    }
  },
  error: {
    image: 'errors/general',
    title: function title() {
      return _I18n.default.text('ui.UIErrorMessage.error.title');
    }
  },
  expired: {
    image: 'errors/hourglass',
    title: function title() {
      return _I18n.default.text('ui.UIErrorMessage.expired.title');
    }
  },
  notFound: {
    image: 'errors/map',
    title: function title() {
      return _I18n.default.text('ui.UIErrorMessage.notFound.title');
    }
  }
};
var errors = (0, _extends2.default)({}, errorTypes, {
  '400': errorTypes.badRequest,
  '403': errorTypes.expired,
  '404': errorTypes.notFound,
  '500': errorTypes.error
});

var ErrorBody = function ErrorBody(props) {
  return _react.default.createElement(_UIResultsMessage.default.defaultProps.Body, (0, _extends2.default)({}, props, {
    className: "private-error-msg__body"
  }));
};

var ErrorImage = function ErrorImage(props) {
  return _react.default.createElement(_UIResultsMessage.default.defaultProps.Image, (0, _extends2.default)({}, props, {
    className: "private-error-msg__image"
  }));
};

var getErrorValues = function getErrorValues(type) {
  return errors[type] || errors.error;
};

var defaultIllustrationProps = {
  width: 175
};

var renderTitle = function renderTitle(title) {
  return _react.default.isValidElement(title) ? title : _react.default.createElement(_H.default, {
    className: "private-error-msg__title"
  }, (0, _lazyEval.default)(title));
};

function UIErrorMessage(_ref) {
  var className = _ref.className,
      illustration = _ref.illustration,
      title = _ref.title,
      type = _ref.type,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className", "illustration", "title", "type"]);

  var _getErrorValues = getErrorValues(type),
      image = _getErrorValues.image,
      imageTitle = _getErrorValues.title;

  return _react.default.createElement(_UIResultsMessage.default, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-error-msg', className),
    illustration: illustration || image,
    Image: ErrorImage,
    title: renderTitle(title || imageTitle)
  }));
}

UIErrorMessage.propTypes = {
  Body: _propTypes.default.elementType,
  children: _propTypes.default.node,
  illustration: (0, _illustrationName.getIllustrationNamePropType)(),
  illustrationProps: _propTypes.default.object,
  title: (0, _createLazyPropType.default)(_propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string])),
  type: _propTypes.default.oneOf(Object.keys(errors))
};
UIErrorMessage.defaultProps = {
  Body: ErrorBody,
  illustrationProps: defaultIllustrationProps,
  type: 'error'
};
UIErrorMessage.displayName = 'UIErrorMessage';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/error/UIErrorMessage.js
// module id = 760
// module chunks = 5 6